"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapV2 = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const UNISWAP_V2_ROUTER_ABI = require("../../abi/uniswap.v2.router.json");
const types_1 = require("../../types");
class UniswapV2 extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            path: optimalRate.data.path,
            router: optimalRate.data.router,
        };
    }
    getRouter(data) {
        return new this.web3Provider.eth.Contract(UNISWAP_V2_ROUTER_ABI, data.router);
    }
    pathWithETH(srcToken, destToken, data) {
        if (this.isETHAddress(srcToken)) {
            return [types_1.ETHER_ADDRESS, ...data.path.slice(1)];
        }
        else if (this.isETHAddress(destToken)) {
            return [...data.path.slice(0, data.path.length - 1), types_1.ETHER_ADDRESS];
        }
        return data.path;
    }
    _swap(srcToken, destToken, data) {
        const _super = Object.create(null, {
            swap: { get: () => super.swap }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const router = this.getRouter(data);
            const path = this.pathWithETH(srcToken, destToken, data);
            const swapData = router.methods
                .swap(data.srcAmount, data.destAmount, path)
                .encodeABI();
            return _super.swap.call(this, srcToken, destToken, data, swapData, data.router);
        });
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._swap(srcToken, destToken, data);
        });
    }
}
exports.UniswapV2 = UniswapV2;
//# sourceMappingURL=uniswap-v2.js.map